import { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import Calling from "./api/Calling";
import { ToastContainer } from "react-toastify";
import Navbar1 from "./components/Navbar/Navbar1";
import Navbar2 from "./components/Navbar/Navbar2";
import Login from "./admin/Login/Login";
import Loader from "./components/Loader";
import Logout from "./admin/Login/Logout";
import Home from "./admin/Home";
import User from "./admin/User/User";
import Controller from "./admin/Controller/Controller";
import NewPw from "./admin/Login/NewPw";
import GoogleAds from "./admin/Ads/GoogleAds";
import INSPACTLOOCK from "./components/INSPACTLOOCK";
import ApiDocs from "./admin/ApiDocs/ApiDocs";
import WithdrawCard from "./admin/WithdrawCard/WithdrawCard";
import InhouseAds from "./admin/Ads/InHouseAds/InHouseAds";
import Notification from "./admin/Controller/Notification";
import NotificationTemplates from "./admin/Controller/NotificationTemplates";
import PromoApps from "./admin/PromoApps/PromoApps";
import SnapPixel from "./admin/SnapPixel/SnapPixel";
import Withdraw from "./admin/Withdraw/Withdraw";
import CashTask from "./admin/CashTask/CashTask";

function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem("admin_box_dollar");
    navigate("/app-admin/panel/login");
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem("admin_box_dollar");
        if (!adminToken) {
          setIsAuthorized(false);

          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  // While the auth check is in flight, show a loader so we don't briefly
  // flash the login screen (or redirect) before we know the real state.
  if (isAuthorized === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader loader={true} />
      </div>
    );
  }

  return (
    <div className="flex roboto-regular min-h-screen">
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        toastClassName="ui-toast"
        progressClassName="ui-toast-progress"
      />
      {/* <INSPACTLOOCK /> */}
      {isAuthorized && <Navbar1 />}
      <div className="w-full">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route
                path="/Logout"
                element={<Logout onLogout={handleLogout} />}
              />

              {/* Controller */}
              <Route path="/controller" element={<Controller />} />

              {/* User  */}
              <Route path="/manage/user/all/data" element={<User />} />

              {/* Google Ads — all ad-unit formats on one page */}
              <Route path="/manage/ads/nativeAds/add" element={<GoogleAds />} />

              {/* Reward Ads */}
              <Route
                path="/manage/ads/inhouseads/add"
                element={<InhouseAds />}
              />

              {/* Admin Change Password*/}
              <Route path="/manage/changePw/" element={<NewPw />} />

              {/* Withdraw Card */}
              <Route path="/manage/withdrawcard" element={<WithdrawCard />} />

              {/* Withdraw requests */}
              <Route path="/manage/withdraw" element={<Withdraw />} />

              {/* Cash tasks — the web games / quizzes on the app's Home */}
              <Route path="/manage/cashtask" element={<CashTask />} />

              {/* Promo apps — cross-app install referral */}
              <Route path="/manage/promo-apps" element={<PromoApps />} />

              {/* Snap Pixel — Snapchat Conversions API config (multi-account) */}
              <Route path="/manage/snap-pixel" element={<SnapPixel />} />

              {/* Push notifications */}
              <Route path="/manage/notification/send" element={<Notification />} />
              <Route path="/manage/notification/templates" element={<NotificationTemplates />} />

              {/* API Documentation */}
              <Route path="/manage/api-docs" element={<ApiDocs />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <>
              <Route
                path="/app-admin/panel/login"
                element={<Login onLogin={handleLoginStatusChange} />}
              />
              <Route
                path="*"
                element={<Navigate to="/app-admin/panel/login" replace />}
              />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
